(()=>{
  'use strict';
  const init=root=>{
    if(!root||root.dataset.trainingInitialized==='true')return;
    root.dataset.trainingInitialized='true';
    const tabs=[...root.querySelectorAll('.training-tab')];
    const items=[...root.querySelectorAll('.grid__item.grid-product')];
    const hydrateHover=target=>{
      const image=target?.closest('.card')?.querySelector('[data-hover-src]');
      if(!image)return;
      image.src=image.dataset.hoverSrc;
      if(image.dataset.hoverSrcset)image.srcset=image.dataset.hoverSrcset;
      delete image.dataset.hoverSrc;
      delete image.dataset.hoverSrcset;
    };
    root.addEventListener('pointerover',event=>hydrateHover(event.target),{passive:true});
    root.addEventListener('focusin',event=>hydrateHover(event.target));
    tabs.forEach(tab=>tab.addEventListener('click',()=>{
      tabs.forEach(item=>{
        const active=item===tab;
        item.classList.toggle('active',active);
        item.setAttribute('aria-selected',String(active));
      });
      const category=tab.dataset.category;
      items.forEach(item=>{
        const hidden=!item.classList.contains(category);
        item.classList.toggle('hidden',hidden);
        item.hidden=hidden;
        item.setAttribute('aria-hidden',String(hidden));
      });
    }));
  };
  const initAll=root=>(root||document).querySelectorAll('[data-training-section]').forEach(init);
  const hydrateImage=image=>{
    if(image.dataset.v4Src)image.src=image.dataset.v4Src;
    if(image.dataset.v4Srcset)image.srcset=image.dataset.v4Srcset;
    delete image.dataset.v4Src;
    delete image.dataset.v4Srcset;
  };
  const observeImages=root=>{
    const images=[...(root||document).querySelectorAll('[data-v4-src],[data-v4-srcset]')];
    if(!images.length)return;
    if(!('IntersectionObserver' in window)){images.forEach(hydrateImage);return;}
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      observer.unobserve(entry.target);
      hydrateImage(entry.target);
    }),{rootMargin:'600px 0px'});
    images.forEach(image=>observer.observe(image));
  };
  const initPage=()=>{initAll();observeImages();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPage);
  else initPage();
  document.addEventListener('shopify:section:load',event=>{initAll(event.target);observeImages(event.target);});
})();
